export enum WorkdayPostOption {
	Workday = -1,
	NonWorkday = -2,
	Default = -3
}